import { render } from "./Navbarre.vue?vue&type=template&id=1b8ce676&scoped=true"
import script from "./Navbarre.vue?vue&type=script&lang=js"
export * from "./Navbarre.vue?vue&type=script&lang=js"

import "./Navbarre.vue?vue&type=style&index=0&id=1b8ce676&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8ce676"]])

export default __exports__